module.exports = __webpack_public_path__ + "img/lsymbol_perce.e2e6c5b1.svg";